import axios from 'axios';
import { Message } from 'element-ui';

// 创建axios实例
const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 150000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
http.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误：', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
http.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data;
    if (res.code && res.code !== 200 && res.code !== 1) {
      Message.error(res.message || '请求失败');
      return Promise.reject(new Error(res.message || '请求失败'));
    }
    return res;
  },
  error => {
    // 对响应错误做点什么
    console.error('响应错误：', error);
    const message = (error.response && error.response.data && error.response.data.message) || error.message || '网络错误';
    Message.error(message);
    return Promise.reject(error);
  }
);

export default http;